import googleAutocomplete from '../utils/GoogleAutocomplete';

export const fetchMapsData = async (value) => {
  const suggestions = await googleAutocomplete(value);
  const mapSuggestions = (suggestions || []).map((suggestion) => ({
    label: suggestion.description,
    value: suggestion
  }));
  return mapSuggestions;
};
